import {ApolloClient, InMemoryCache} from "@apollo/client";
import {appConfig} from "../config/app";

export const graphqlClient = new ApolloClient({
    uri: appConfig.graphqlUrl,
    cache: new InMemoryCache()
});
